import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Tabs, Tab } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import PageHeader from '../../components/PageHeader';
import UploadBillTab from './UploadBillTab';
import UploadedBillsTab from './UploadedBillsTab';
import { clearParsedData } from './billParsingSlice';

const BillParsingHome = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState('upload');

  useEffect(() => {
    if (activeTab === 'upload') {
      dispatch(clearParsedData());
    }
  }, [activeTab, dispatch]);

  return (
    <Container fluid>
      <Row>
        <Col>
          <PageHeader title={t('Bill Parsing')} />
        </Col>
      </Row>
      <Row>
        <Col>
          <Tabs activeKey={activeTab} onSelect={(k) => setActiveTab(k)} className="custom-tab-bar">
            <Tab eventKey="upload" title={t('Upload Bill')} className="custom-tab-content">
              <Row className="my-2">
                <Col>
                  <UploadBillTab onSuccess={() => setActiveTab('uploaded')} />
                </Col>
              </Row>
            </Tab>
            <Tab eventKey="uploaded" title={t('Uploaded Bills')} className="custom-tab-content">
              <Row className="my-2">
                <Col>{activeTab === 'uploaded' && <UploadedBillsTab />}</Col>
              </Row>
            </Tab>
          </Tabs>
        </Col>
      </Row>
    </Container>
  );
};

export default BillParsingHome;
